
























import { ActivityGroup } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'SkillsItem',
  props: {
    skill: Object as () => ActivityGroup,
  },
});
